"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var _constants = require("../../assets/js/constants");

var theme = {
  'primary': {
    'inactive': {
      'color': _constants.COLORS.WHITE,
      'border': _constants.COLORS.lightGrey,
      'background': _constants.COLORS.lightGrey,
      'opacity': '1'
    },
    'active': {
      'color': _constants.COLORS.WHITE,
      'border': _constants.COLORS.PINK_BRIGHT,
      'background': _constants.COLORS.PINK_BRIGHT,
      'opacity': '1'
    },
    'hover': {
      'color': _constants.COLORS.WHITE,
      'border': _constants.COLORS.PINK_BRIGHT,
      'background': _constants.COLORS.PINK_BRIGHT,
      'opacity': '1'
    }
  },
  'secondary': {
    'inactive': {
      'color': _constants.COLORS.PINK_BRIGHT,
      'border': _constants.COLORS.PINK_BRIGHT,
      'background': _constants.COLORS.TRANSPARENT,
      'opacity': '1'
    },
    'active': {
      'color': _constants.COLORS.PINK_BRIGHT,
      'border': _constants.COLORS.PINK_BRIGHT,
      'background': _constants.COLORS.TRANSPARENT,
      'opacity': '1'
    },
    'hover': {
      'color': _constants.COLORS.PINK,
      'border': _constants.COLORS.PINK,
      'background': _constants.COLORS.TRANSPARENT,
      'opacity': '1'
    }
  },
  'grey': {
    'inactive': {
      'color': _constants.COLORS.GREY_BLUE,
      'border': _constants.COLORS.LIGHT_BLUE,
      'background': _constants.COLORS.LIGHT_BLUE,
      'opacity': '1'
    },
    'active': {
      'color': _constants.COLORS.BRIGHT_BLUE,
      'border': _constants.COLORS.LIGHT_BLUE,
      'background': _constants.COLORS.LIGHT_BLUE,
      'opacity': '1'
    },
    'hover': {
      'color': _constants.COLORS.WHITE,
      'border': _constants.COLORS.BRIGHT_BLUE,
      'background': _constants.COLORS.BRIGHT_BLUE,
      'opacity': '1'
    }
  },
  'stretch': {
    'inactive': {
      'color': _constants.COLORS.GREY_BLUE,
      'border': _constants.COLORS.LIGHT_BLUE,
      'background': _constants.COLORS.LIGHT_BLUE,
      'opacity': '1'
    },
    'active': {
      'color': _constants.COLORS.BRIGHT_BLUE,
      'border': _constants.COLORS.LIGHT_BLUE,
      'background': _constants.COLORS.LIGHT_BLUE,
      'opacity': '1'
    },
    'hover': {
      'color': _constants.COLORS.WHITE,
      'border': _constants.COLORS.BRIGHT_BLUE,
      'background': _constants.COLORS.BRIGHT_BLUE,
      'opacity': '1'
    }
  },
  'error': {
    'inactive': {
      'color': _constants.COLORS.red,
      'border': _constants.COLORS.grey,
      'background': _constants.COLORS.white,
      'opacity': '0.5'
    },
    'active': {
      'color': _constants.COLORS.red,
      'border': _constants.COLORS.grey,
      'background': _constants.COLORS.white,
      'opacity': '1'
    },
    'hover': {
      'color': _constants.COLORS.red,
      'border': _constants.COLORS.red,
      'background': _constants.COLORS.white,
      'opacity': '1'
    }
  }
};
exports.theme = theme;